import { render } from "./step6_verification.vue?vue&type=template&id=66c8f2ce&scoped=true"
import script from "./step6_verification.vue?vue&type=script&lang=js"
export * from "./step6_verification.vue?vue&type=script&lang=js"

import "./step6_verification.vue?vue&type=style&index=0&id=66c8f2ce&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66c8f2ce"]])

export default __exports__